import { render, staticRenderFns } from "./Movies-card.vue?vue&type=template&id=7a52f11a&"
import script from "./Movies-card.vue?vue&type=script&lang=js&"
export * from "./Movies-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports